function notifyMeHandler() {
  const sectionId = document.getElementById("section-id").value;
  const cartBtn = document.querySelector(`button#ProductSubmitButton-${sectionId}:not([disabled])`);
  const nmPortal = document.querySelector(".notify-button__container");

  if (cartBtn !== null) {
    nmPortal.style.setProperty("display", "none", "important");
    document.querySelector(".notify-button__container > .notify-button").style.removeProperty("display");
  }

  if (cartBtn === null) {
    nmPortal.style.setProperty("display", "flex", "important");
    document.querySelector(".notify-button__container > .notify-button").style.removeProperty("display");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  notifyMeHandler();

  subscribe(PUB_SUB_EVENTS.variantChange, () => {
    notifyMeHandler();
  });
});
